import api from "../../../utils/useApi";
import {
  FunctionCloneSetValueToSesstion,
  FunctionGetCurrentLocationApi,
  FunctionGetDataFromSessionStorage,
} from "../../../utils/useFunction";

const BasketLoadAllPrevData = async ({
  setRefNumber,
  setDateTime,
  setAddress,
  // setAddressDetail,
  user,
  address,
  setClicked,
  setTellUsMore,
  setDetailAddress,
}) => {
  if (user) {
    const gen = String(new Date().getTime());
    setRefNumber(gen?.slice(3, 13));
  }

  const HasDateAndTime = FunctionGetDataFromSessionStorage("date_time");
  const prevTellUsMore = FunctionGetDataFromSessionStorage("tellUsMore");
  // const HasAddress = FunctionGetDataFromSessionStorage("address");
  // const HasAddressDetail = FunctionGetDataFromSessionStorage("addressDetail");
  // const HasSameDayServie = FunctionGetDataFromSessionStorage("sameDayService");
  // const getAddressDetail = sessionStorage.getItem("locationData");
  // const getAddressLocation = sessionStorage.getItem("location");
  // const locationData = JSON.parse(getAddressDetail);
  // const getAddressLocationJSON = JSON.parse(getAddressLocation);
  // const userHasAddress = user?.address?.length > 0;
  if (prevTellUsMore === false) {
    setTellUsMore(false);
  }

  if (prevTellUsMore === !false || prevTellUsMore === null) {
    setTellUsMore(true);
  }

  const { data } = await api.get(`/address?owner=${user?._id}`);
  const userHasAddress = data?.address?.length > 0;

  // console.log("prevTellUsMore", prevTellUsMore);
  // console.log("CHECK POINT (BasketLoadAllPrevData):", {
  //   user,
  //   address,
  //   HasDateAndTime,
  //   HasSameDayServie,
  //   userHasAddress,
  //   HasAddressDetail,
  // });

  // if (HasAddressDetail) {
  //   setAddressDetail(HasAddressDetail);
  // }

  // if (address?.detail || address?.detail === "") {
  //   setAddressDetail(address?.detail);
  // }

  if (!address && userHasAddress) {
    // console.log("IN 2");
    if (setAddress) {
      setAddress(user?.address[0]);
    }
    if (setDetailAddress) {
      setDetailAddress(user?.address[0]?.detail);
    }
  }
  if (HasDateAndTime) {
    // console.log("IN 3");
    setDateTime(HasDateAndTime);
  }
  // if (HasSameDayServie) {
  //   // console.log("IN 4");
  //   setSameDayService(HasSameDayServie);
  // }

  setClicked(false);

  // if (locationData && getAddressDetail) {
  //   // console.log("IN 5");

  //   // FunctionCloneSetValueToSesstion("address", setAddress, {
  //   //   ...locationData,
  //   //   where: locationData?.description,
  //   //   link: getAddressLocationJSON?.link,
  //   //   location:
  //   //     locationData?.terms?.findIndex((item) => item.value === "Bangkok") !==
  //   //     -1
  //   //       ? "BANGKOK"
  //   //       : "PATTAYA",
  //   // });
  //   sessionStorage.removeItem("locationData");
  //   sessionStorage.removeItem("location");
  // } else
  // if (userHasAddress && !HasAddress) {
  //   // console.log("IN 6");
  //   // FunctionCloneSetValueToSesstion("address", setAddress, user?.address[0]);

  //   if (!sessionStorage.getItem("addressDetail")) {
  //     // console.log("IN 7");
  //     FunctionCloneSetValueToSesstion(
  //       "addressDetail",
  //       setAddressDetail,
  //       user?.address[0]?.detail
  //     );
  //   }
  // }
  //  else if (
  // !address &&
  // !userHasAddress &&
  // !locationData &&
  // !getAddressDetail
  // ) {
  // console.log("IN 8");
  // FunctionGetCurrentLocationApi(setAddress);
  // }

  // console.log("OUT");

  return () => {};
};

export default BasketLoadAllPrevData;
